import store from "./index";

const getters = {
    login: state => state.user.login,
    user: state => state.user.user,
    sid: state => state.user.sid,
    login_type: state => state.user.login_type,
    avatar: state => state.user.avatar,
    commonTabRoute: state => state.user.commonTabRoute,
    name: state => state.user.name,
    folder_routers: state => state.folder.routers,
    addRouters: state => state.folder.addRouters,
    mailId: state => state.mail.mailId,
    draftId: state => state.mail.draftId,
    pageType: state => state.mail.pageType,
    mailType: state => state.mail.mailType,
    folderId: state => state.folder.folderId,
    folderName: state => state.folder.folderName,
    folders: state => state.folder.folders,
    currWriteType: state => state.mail.currWriteType,
    mailData: state => state.mail.mailData,
    mailIndex: state => state.mail.mailIndex,
    largeAttachFreeSize: state => state.mail.largeAttachFreeSize,
    indexListData: state => state.mail.indexListData,
    checkedMails: state => state.mail.checkedMails,
    writeDataMd5: state => state.mail.writeDataMd5,
    currDraftDataChange: state => state.mail.currDraftDataChange,
    mailIndexParamRecord: state => state.mail.mailIndexParamRecord,
    acrossSelectCount: state => state.mail.acrossSelectCount,
    acrossSelectFlag: state => state.mail.acrossSelectFlag,
    indexListParams: state => state.mail.indexListParams,
    checkedAddress: state => state.address.checkedAddress,
    indexListAddress: state => state.address.indexListAddress,
    orgVersion: state => state.address.orgVersion,
    persVersion: state => state.address.persVersion,
    persTreeFresh: state => state.address.persTreeFresh,
    orgAddress: state => state.address.orgAddress,
    persAddress: state => state.address.persAddress,
    currGroupData: state => state.address.currGroupData,
    groupOperType: state => state.address.groupOperType,
    personOperType: state => state.address.personOperType,
    currAddressType: state => state.address.currAddressType,
    treeViewLastClickNodeId: state => state.address.treeViewLastClickNodeId,
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js